import React from "react";

const FrontIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 6.65611C6 2.9802 8.97997 0 12.6561 0H34V9.47202C34 11.31 32.5102 12.8001 30.672 12.8001H22.0001C20.2328 12.8001 18.8001 14.2328 18.8001 16.0001V36.6722C18.8001 38.5101 17.31 40 15.472 40H6V6.65611Z",
  fill: "#001B38"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.44 16.0799C13.44 20.8517 17.3082 24.7199 22.08 24.7199C26.8517 24.7199 30.72 20.8517 30.72 16.0799C30.72 11.3082 26.8517 7.43994 22.08 7.43994C17.3082 7.43994 13.44 11.3082 13.44 16.0799Z",
  fill: "url(#paint0_linear_2785_897)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M13.44 16.0799C13.44 20.8517 17.3082 24.7199 22.08 24.7199C26.8517 24.7199 30.72 20.8517 30.72 16.0799C30.72 11.3082 26.8517 7.43994 22.08 7.43994C17.3082 7.43994 13.44 11.3082 13.44 16.0799Z",
  fill: "url(#paint1_linear_2785_897)"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2785_897",
  x1: 15.995,
  y1: 9.60327,
  x2: 28.988,
  y2: 22.686,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF0057",
  stopOpacity: 0.16
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.861,
  stopColor: "#FF0057"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_2785_897",
  x1: 15.995,
  y1: 9.60327,
  x2: 28.988,
  y2: 22.686,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF0057",
  stopOpacity: 0.16
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.861,
  stopColor: "#FF0057"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(FrontIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;